import { Products } from '../index';
import { useCallback, useContext, useEffect, useMemo, useState, Fragment } from 'react';
import { ButtonCustom } from 'components/common/ButtonCustom';
import { TextForm } from 'components/common/form-item/TextForm';
import { PATH_PAGE, PER_PAGE_DEFAULT, QUERY_KEY, SUPPLIER, SUPPLIER_OPTIONS } from '../../../constant';
import { ButtonGradient } from 'components/common/button/ButtonGradient';
import { TableV2 } from 'components/common/TableV2';
import { useInfiniteQuery, useMutation, useQuery } from 'react-query';
import { searchSim, searchSimInfinite, sendLockSim } from '../../../services/product';
import { get, isEmpty } from 'lodash';
import { PopupFilterSim } from './PopupFilterSim';
import { SimContext } from './SimContext';
import { getIconSupplier } from '../../../utils/getIconSupplier';
import { FilterItem } from '../../../components/common/FilterItem';
import { getLabelTypeNumber, redirectDownload } from '../../../utils/utils';
import { PaginationAuto } from '../../../components/common/pagination/PaginationAuto';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import useCheckDeviceMobi from '../../../hooks/useCheckDeviceMobi';
import toast from 'react-hot-toast';
import { AccountAuthen } from '../../../components/common/AccountAuthen';
import AuthContext from '../../../context/AuthProvider';
import { getOptionSearch } from '../../../services/common';
import { NotFoundIcon } from '../../../assets/images/common';
import { checkReqPayment } from 'services/payment';
import { AxiosResponse } from 'axios';
import { sendBookingSim } from 'services/booking';
import { SpinCustom } from 'components/common/SpinCustom';
import { Dialog, Transition } from '@headlessui/react';
import { ComingSoonIcon } from 'assets/images';
import Cookies from 'js-cookie';

export const ProductsSim = () => {
  const navigate = useNavigate();
  const isMobile = useCheckDeviceMobi();

  const { userLogin } = useContext(AuthContext);

  const [dataTable, setDataTable] = useState<{
    items: Array<any>;
    numberPerPage: number;
    pageNumber: number;
  }>({
    items: [],
    numberPerPage: 0,
    pageNumber: 0,
  });
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(PER_PAGE_DEFAULT);
  const [totalPage, setTotalPage] = useState<number>(1);

  const [isShowNotification, setIsShowNotification] = useState<boolean>(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const [searchString, setSearchString] = useState<string>('');
  const [traSau, setTraSau] = useState<number>(0);
  const [traTruoc, setTraTruoc] = useState<number>(0);
  const [preNumber, setPreNumber] = useState<Array<string>>([]);
  const [typeNumber, setTypeNumber] = useState<Array<string>>([]);
  const [supplier, setSupplier] = useState<Array<number>>([SUPPLIER.MOBIFONE, SUPPLIER.VINAPHONE, SUPPLIER.SAYMEE]);

  const [isOpenFilter, setIsOpenFilter] = useState(false);

  const [searchParams, setSearchParams] = useState<any>({
    preNumbers: preNumber,
    srcStrs: searchString ? [searchString] : [],
    types: traTruoc ? [0] : traSau ? [1] : [],
    supplier: supplier?.length ? supplier : [SUPPLIER.MOBIFONE, SUPPLIER.VINAPHONE, SUPPLIER.SAYMEE],
    groupMsisdns: typeNumber?.length === 1 && Number(typeNumber[0]) === -1 ? [] : typeNumber,
    page: 1,
    sizeOfPage: PER_PAGE_DEFAULT,
  });

  const { data: dataCommonOption } = useQuery(QUERY_KEY.GET_COMMON_OPTION, () => getOptionSearch(), {
    enabled: !!Cookies.get('token'),
    retry: 0,
    refetchOnWindowFocus: false,
  });

  const { data: dataCheckReqPayment } = useQuery(QUERY_KEY.REQ_PAYMENT, () => checkReqPayment(), { enabled: false });

  const mutationSendBooking = useMutation((param: any) => sendBookingSim(param), {
    onSuccess: (response: AxiosResponse<any>) => {
      if (response.data.data.data) {
        toast.success('Giữ số thành công!');
        navigate(`${PATH_PAGE.STATISTIC_TRANSACTION}/info/${response.data.data.transCode}`);
      } else {
        toast.error('Số thuê bao đang ở 1 giao dịch giữ số khác. Vui lòng chọn số khác hoặc thử lại sau');
      }
    },
  });

  const mutationLockSim = useMutation((param: any) => sendLockSim(param), {
    onSuccess: (response: AxiosResponse<any>) => {
      if (response.data.data.data && get(response, 'data.data.data.ssid', '')) {
        mutationSendBooking.mutate({
          msisdn: get(response, 'data.data.data.items[0].msisdn', ''),
          custName: userLogin.fullName,
          custPhone: userLogin.mobile,
          ssid: get(response, 'data.data.data.ssid', ''),
          addrCityId: userLogin.provinceId,
          addrDistId: userLogin.districtId,
          addrCurr: userLogin.address,
          typeSource: 'CTV',
          addrWardId: 0,
          custEmail: userLogin.email,
          idNo: userLogin.passportId,
          userType: 'MEM',
        });
      } else {
        toast.error('Số thuê bao đang ở 1 giao dịch giữ số khác. Vui lòng chọn số khác hoặc thử lại sau');
      }
    },
  });
  // 1 = du dk
  // 161 =  tài khoản chưa xác thực
  // 162 =  số dư chưa đủ
  // 163 =  giới hạn 1 lần 1 ngày
  // 164 =  thiếu thông tin ngân hàng
  const statusReqPayment = useMemo(() => {
    return dataCheckReqPayment?.data?.data?.code;
  }, [dataCheckReqPayment]);

  const listGroupMsisdnOptions = useMemo(() => {
    return dataCommonOption?.data?.data?.sort((a: any, b: any) => a.id - b.id) || [];
  }, [dataCommonOption?.data?.data]);

  const {
    data: simData,
    isFetching,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [QUERY_KEY.SIM_LIST, searchParams],
    queryFn: searchSimInfinite,
    enabled: !!Cookies.get('token'),
    retry: 0,
    refetchOnWindowFocus: false,
    getNextPageParam: (lastPage) => {
      return lastPage.data?.data?.items?.length < perPage ? undefined : lastPage?.data?.data?.pageNumber + 1;
    },
  });

  useEffect(() => {
    if (simData?.pages?.length) {
      setDataTable({
        // items: searchSimQuery?.data?.data?.data?.items,
        items: simData?.pages?.flatMap((item) => item?.data?.data?.items ?? []) ?? [],
        numberPerPage: searchParams?.numberPerPage || PER_PAGE_DEFAULT,
        pageNumber: 0,
      });
    } else {
      setDataTable({ items: [], numberPerPage: 0, pageNumber: 0 });
    }
  }, [searchParams?.numberPerPage, simData?.pages]);

  const fetchItems = useCallback(
    (ref?: HTMLDivElement | null) => {
      if (ref) {
        const { scrollHeight, scrollTop, clientHeight } = ref;

        if (scrollHeight - scrollTop - clientHeight < 300 && !isFetching) {
          fetchNextPage();
        }
      }
    },
    [fetchNextPage, isFetching]
  );

  const mutationSearchSimMobile = useMutation((param: any) => searchSim(param), {
    onSuccess: (response: any) => {
      if (response?.data?.data?.data) {
        setDataTable({
          items: [...dataTable.items, ...response.data.data.data.items],
          numberPerPage: response.data.data.data.numberPerPage,
          pageNumber: response.data.data.data.pageNumber,
        });
        return;
      }
    },
    onError: (error) => {
      setDataTable({ items: [], numberPerPage: 0, pageNumber: 0 });
    },
  });

  const onSearchSim = (_param?: { perPage?: number; currentPage?: number }) => {
    const keySearch = {
      preNumbers: preNumber,
      srcStrs: searchString ? [searchString.trim()] : [],
      types: traTruoc ? [0] : traSau ? [1] : [],
      supplier: supplier?.length ? supplier : [SUPPLIER.MOBIFONE, SUPPLIER.VINAPHONE, SUPPLIER.SAYMEE],
      groupMsisdns: typeNumber?.length === 1 && Number(typeNumber[0]) === -1 ? [] : typeNumber,
      page: _param?.currentPage || currentPage,
      sizeOfPage: _param?.perPage || perPage,
    };

    setSearchParams(keySearch);
  };

  const onNextPageMobile = () => {
    setCurrentPage(currentPage + 1);
    const keySearch = {
      preNumbers: preNumber,
      srcStrs: searchString ? [searchString.trim()] : [],
      types: traTruoc ? [0] : traSau ? [1] : [],
      supplier: supplier?.length ? supplier : [SUPPLIER.MOBIFONE, SUPPLIER.VINAPHONE, SUPPLIER.SAYMEE],
      groupMsisdns: typeNumber?.length === 1 && Number(typeNumber[0]) === -1 ? [] : typeNumber,
      page: currentPage + 1,
      sizeOfPage: perPage,
    };

    mutationSearchSimMobile.mutate(keySearch);
  };

  const onHoldSim = (sim: any) => {
    mutationLockSim.mutate({
      ssid: 0,
      listMsisdn: [get(sim, 'msisdn')],
    });
  };

  const renderRow = useCallback(
    (row: any, index: number) => {
      return (
        <tr
          key={row?.supplier + '-' + index}
          className="cursor-fancy border-b bg-white hover:z-50 hover:shadow-[0px_0px_10px_rgba(209,209,209,0.2)] hover:drop-shadow-[0px_0px_8px_rgba(255,158,110,0.6)]"
        >
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="px-2.5 py-2.5 text-center text-base font-bold text-baseColor"
          >
            {index + 1 + (currentPage - 1) * perPage}
          </th>
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="flex flex-row items-center justify-center px-2.5 py-2.5 text-center text-base font-normal"
          >
            {getIconSupplier(row?.supplier)}
          </th>
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="px-2.5 py-2.5 text-center text-base font-bold text-baseColor"
          >
            {row?.msisdn}
          </th>
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="px-2.5 py-2.5 text-center text-base font-medium text-baseColor"
          >
            {row?.typeStr}
          </th>
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="px-2.5 py-2.5 text-center text-base font-medium text-baseColor"
          >
            {row?.groupName}
          </th>
          <th
            onClick={() => {
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
            scope="row"
            className="px-2.5 py-2.5 text-center text-base font-medium text-[#F15836]"
          >
            {row?.shareValue ? row?.shareValue.toLocaleString('vi') : '-'}
          </th>
          <th
            scope="row"
            className="px-2.5 py-2.5 text-center font-normal text-gray-700"
            onClick={(e: any) => {
              if (e.target.nodeName !== 'TH') {
                return;
              }
              if (userLogin?.statusVerify === 1) {
                navigate(row?.msisdn, {
                  state: row,
                });
                return;
              }
              setIsShowNotification(true);
            }}
          >
            <div className={'flex flex-row items-center justify-center space-x-2.5'}>
              <ButtonGradient
                className={'h-[30px] w-[100px]'}
                background={'bg-white'}
                onClick={() => {
                  if (userLogin?.statusVerify === 1) {
                    navigator?.clipboard?.writeText(row.link);
                    toast.success('Sao chép link thành công!');
                    return;
                  }
                  setIsShowNotification(true);
                }}
                // onClick={() => setShowDialog(true)}
              >
                <span className={'text-sm font-semibold text-[#F15836]'}>Lấy link</span>
              </ButtonGradient>
              <ButtonCustom
                label={'Giữ số'}
                // onClick={() => {
                //   if (userLogin?.statusVerify === 1) {
                //     onHoldSim(row);
                //     return;
                //   }
                //   setIsShowNotification(true);
                // }}
                onClick={() => setShowDialog(true)}
                background={'bg-[#F15836]'}
                className={'h-[30px] w-[100px] !rounded-l-[10px] !text-sm !font-semibold'}
              />
            </div>
          </th>
        </tr>
      );
    },
    [currentPage, perPage, userLogin?.statusVerify]
  );

  const clearSearch = () => {
    setPreNumber([]);
    setSupplier([]);
    setTypeNumber([]);
    setTraTruoc(0);
    setTraSau(0);
    setSearchString('');
  };

  useEffect(() => {
    setCurrentPage(1);
    setPerPage(PER_PAGE_DEFAULT);
    const keySearch = {
      preNumbers: preNumber,
      srcStrs: searchParams?.searchString ? [searchParams?.searchString] : [],
      types: traTruoc ? [0] : traSau ? [1] : [],
      supplier: supplier?.length ? supplier : [SUPPLIER.MOBIFONE, SUPPLIER.VINAPHONE, SUPPLIER.SAYMEE],
      groupMsisdns: typeNumber?.length === 1 && Number(typeNumber[0]) === -1 ? [] : typeNumber,
      page: 1,
      sizeOfPage: PER_PAGE_DEFAULT,
    };
    setSearchParams(keySearch);
  }, [preNumber, traTruoc, traSau, supplier, typeNumber, searchParams?.searchString]);

  const showButtonClear =
    !isEmpty(preNumber) || !isEmpty(typeNumber) || !isEmpty(supplier) || traTruoc !== 0 || traSau !== 0;

  return (
    <>
      {(isFetching || mutationLockSim.isLoading || mutationSendBooking.isLoading) && <SpinCustom />}
      <SimContext.Provider
        value={{
          traSau,
          traTruoc,
          preNumber,
          typeNumber,
          setTraTruoc,
          setPreNumber,
          setTraSau,
          setTypeNumber,
          supplier,
          setSupplier,
        }}
      >
        <Products name={PATH_PAGE.PRODUCTS_SIM}>
          <div className={'mb-6 mt-4 flex flex-row space-x-2'}>
            <div className={'relative h-full w-full'}>
              <TextForm
                placeholder={'Nhập để tìm kiếm đuôi số'}
                value={searchString}
                onChange={(e) => setSearchString(e.target.value)}
                className={'h-[40px] rounded-[10px] pl-6 focus:outline-none'}
              />
            </div>
            <ButtonCustom
              onClick={() => {
                setCurrentPage(1);
                onSearchSim({ currentPage: 1 });
              }}
              label={
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M13.4688 12.7812L17.5938 16.9062"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8.3125 14.1562C11.9196 14.1562 14.8438 11.2321 14.8438 7.625C14.8438 4.01789 11.9196 1.09375 8.3125 1.09375C4.70539 1.09375 1.78125 4.01789 1.78125 7.625C1.78125 11.2321 4.70539 14.1562 8.3125 14.1562Z"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              className={'h-[40px] w-[40px] px-2.5'}
            />
            <ButtonCustom
              onClick={() => setIsOpenFilter(true)}
              label={
                <div className={'flex flex-row items-center justify-center space-x-0.5'}>
                  {showButtonClear ? (
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clipPath="url(#clip0_573_26031)">
                        <path
                          d="M10.9518 20.5827H15.1185V18.416H10.9518V20.5827ZM6.78516 14.0827H19.2852V11.916H6.78516V14.0827ZM3.66016 5.41602V7.58268H22.4102V5.41602H3.66016Z"
                          fill="#F15836"
                        />
                        <circle cx="20.12" cy="5.41492" r="4.91296" fill="#FFE1D0" />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M20.1182 0C17.1276 0 14.7031 2.42448 14.7031 5.41509C14.7031 8.40569 17.1276 10.8302 20.1182 10.8302C23.1088 10.8302 25.5333 8.40569 25.5333 5.41509C25.5333 2.42448 23.1088 0 20.1182 0ZM22.4654 4.49945C22.5086 4.45004 22.5415 4.39249 22.5622 4.33018C22.5828 4.26788 22.5908 4.20207 22.5857 4.13663C22.5805 4.07119 22.5623 4.00744 22.5321 3.94914C22.502 3.89084 22.4605 3.83915 22.41 3.79713C22.3596 3.75511 22.3013 3.72359 22.2385 3.70444C22.1757 3.68529 22.1097 3.67889 22.0445 3.68562C21.9792 3.69235 21.9159 3.71207 21.8583 3.74361C21.8007 3.77516 21.7501 3.81791 21.7093 3.86933L19.5925 6.409L18.4971 5.31319C18.4043 5.22351 18.2799 5.17389 18.1509 5.17502C18.0218 5.17614 17.8983 5.22791 17.807 5.31918C17.7158 5.41046 17.664 5.53393 17.6629 5.663C17.6618 5.79207 17.7114 5.91643 17.801 6.00927L19.2779 7.48611C19.3263 7.53445 19.3842 7.57219 19.4479 7.59691C19.5117 7.62163 19.5799 7.63279 19.6482 7.62969C19.7165 7.62658 19.7835 7.60928 19.8447 7.57888C19.906 7.54848 19.9602 7.50566 20.004 7.45313L22.4654 4.49945Z"
                          fill="#F15836"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_573_26031">
                          <rect width="25" height="26" fill="white" transform="translate(0.535156)" />
                        </clipPath>
                      </defs>
                    </svg>
                  ) : (
                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M11.1628 20.5827H15.3294V18.416H11.1628V20.5827ZM6.99609 14.0827H19.4961V11.916H6.99609V14.0827ZM3.87109 5.41602V7.58268H22.6211V5.41602H3.87109Z"
                        fill="#F15836"
                      />
                    </svg>
                  )}
                  <span className={'text-sm !font-medium text-[#404040]'}>Bộ lọc</span>
                </div>
              }
              className={'h-[40px] min-w-[100px]'}
              background={'bg-[#FFE1D0]'}
            />
          </div>

          <div className={'flex w-full flex-wrap gap-2 space-x-2'}>
            {traTruoc === 1 && <FilterItem label={'Trả trước'} onClear={() => setTraTruoc(0)} />}
            {traSau === 1 && <FilterItem label={'Trả sau'} onClear={() => setTraSau(0)} />}
            {preNumber?.map((packType, index) => (
              <FilterItem
                label={packType}
                key={`${index}-preNumber`}
                onClear={() => setPreNumber((v) => v.filter((item) => item !== packType))}
              />
            ))}
            {typeNumber?.map((packType, index) => (
              <FilterItem
                label={getLabelTypeNumber(packType, listGroupMsisdnOptions)}
                key={`${index}-typeNumber`}
                onClear={() => setTypeNumber((v) => v.filter((item) => item !== packType))}
              />
            ))}
            {supplier?.map((_item, index) => (
              <FilterItem
                label={SUPPLIER_OPTIONS.find((item) => item.value === _item)?.name || '-'}
                key={`${index}-supplier`}
                onClear={() => {
                  setSupplier((v) => v.filter((item) => item !== _item));
                  setPreNumber([]);
                }}
              />
            ))}
            {showButtonClear && (
              <button className={'text-sm font-normal text-[#F15836]'} onClick={() => clearSearch()}>
                Xóa điều kiện
              </button>
            )}
          </div>
          {!isMobile && (
            <div className={'mt-4 w-full'}>
              <TableV2
                bodyMaxHeightClass={'max-h-[520px]'}
                labelHeaders={labelHeader}
                dataRows={dataTable.items}
                renderRow={renderRow}
                onScroll={(e: any) => fetchItems(e.target as HTMLDivElement)}
                stickyHeader={true}
              />{' '}
            </div>
          )}
          {!dataTable.items.length && currentPage === 1 && (
            <div className={'mt-4 flex h-fit w-full flex-col items-center justify-center'}>
              <img src={NotFoundIcon} alt={'not-found'} />
              <span className={'mt-2 text-[18px] font-bold leading-[28px] text-[#A1A1AA]'}>Không tìm thấy dữ liệu</span>
            </div>
          )}
          <>
            {isMobile && (
              <div className={'flex h-full w-full flex-col space-y-2.5 md:hidden '}>
                <InfiniteScroll
                  dataLength={dataTable.items.length + 15}
                  next={() => onNextPageMobile()}
                  hasMore={true}
                  loader={<></>}
                  endMessage={<></>}
                  refreshFunction={() => console.log('refresh')}
                  pullDownToRefresh
                  pullDownToRefreshThreshold={50}
                  pullDownToRefreshContent={<></>}
                  releaseToRefreshContent={<></>}
                  className={'space-y-2.5'}
                >
                  {dataTable.items.map((item, index) => (
                    <div
                      key={index}
                      className={
                        'flex min-h-[116px] w-full flex-col justify-between rounded-t-[16px] rounded-bl-[16px] bg-white' +
                        ' px-4 py-2 shadow-base'
                      }
                    >
                      <div
                        className={'grid w-full grid-cols-5 '}
                        onClick={() => {
                          if (userLogin?.statusVerify === 1) {
                            navigate(item.msisdn, { state: item });
                            return;
                          }
                          setIsShowNotification(true);
                        }}
                      >
                        <div className={'col-span-3 flex flex-row items-center justify-between space-x-1.5'}>
                          <div className={'min-h-[58px] min-w-[58px]'}>{getIconSupplier(item?.supplier)}</div>
                          <div className={'flex w-full flex-col'}>
                            <span className={'text-lg font-bold text-[#404040]'}>{item.msisdn}</span>
                            <span className={'text-sm font-normal text-[#818181]'}>{item.groupName}</span>
                            <span className={'text-sm font-normal text-[#818181]'}>{item.typeStr}</span>
                          </div>
                        </div>
                        <div className={'col-span-2 flex w-full flex-col items-end justify-center'}>
                          <div className={'flex flex-row items-center space-x-0.5 text-base font-bold text-[#F15836]'}>
                            <svg
                              width="19"
                              height="19"
                              viewBox="0 0 19 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.87891 2.89258C7.20831 2.89495 6.56585 3.1624 6.09166 3.63658C5.61747 4.11077 5.35003 4.75323 5.34766 5.42383C5.34766 5.87383 5.47534 6.29177 5.68178 6.65458C4.66872 7.24745 3.87559 8.08895 3.44922 9.08008H3.37891C3.34174 9.08092 3.30479 9.07423 3.27028 9.06039C3.23578 9.04656 3.20444 9.02587 3.17815 8.99959C3.15186 8.9733 3.13118 8.94196 3.11734 8.90745C3.10351 8.87295 3.09681 8.83599 3.09766 8.79883C3.09766 8.69983 3.14828 8.62108 3.22084 8.57045L2.57003 7.65639C2.38573 7.78455 2.23515 7.95537 2.13114 8.1543C2.02712 8.35322 1.97275 8.57435 1.97266 8.79883C1.97266 9.4907 2.48903 10.0577 3.15053 10.1702C3.12184 10.3671 3.09766 10.5634 3.09766 10.7676C3.09766 12.1693 3.84241 13.3843 4.92578 14.2832C4.78966 14.8457 4.85772 15.4453 5.29478 15.883C5.61746 16.2029 6.05344 16.3823 6.50781 16.3823C6.96219 16.3823 7.39817 16.2029 7.72084 15.883L7.93178 15.672C8.37109 15.753 8.81266 15.8301 9.28516 15.8301C9.75766 15.8301 10.1992 15.753 10.6385 15.672L10.8495 15.883C11.1721 16.2029 11.6081 16.3823 12.0625 16.3823C12.5169 16.3823 12.9529 16.2029 13.2755 15.883C13.7036 15.4543 13.7677 14.8721 13.6445 14.3181C14.0956 13.9517 14.4818 13.5121 14.787 13.0176H16.0352V8.51758H14.7521C14.5479 8.18604 14.3059 7.87931 14.031 7.60352L14.3477 5.86314V5.14258H13.7852C13.7852 5.14258 12.434 5.16508 11.2888 6.02177C10.9881 5.93502 10.683 5.86442 10.3747 5.81027C10.3972 5.68539 10.4102 5.55545 10.4102 5.42383C10.4102 4.03277 9.26997 2.89258 7.87891 2.89258ZM7.87891 4.01758C8.66078 4.01758 9.28516 4.64195 9.28516 5.42383C9.28516 5.52058 9.26772 5.61283 9.24972 5.70508C8.34241 5.70958 7.48572 5.88508 6.70159 6.17983C6.55224 5.956 6.47257 5.69292 6.47266 5.42383C6.47266 4.64195 7.09703 4.01758 7.87891 4.01758ZM13.082 6.37333C13.091 6.37108 13.091 6.37502 13.0995 6.37333L12.8885 7.65583L12.8362 7.95508L13.082 8.16602C13.4576 8.49129 13.7678 8.88512 13.9961 9.32645L14.1542 9.64258H14.9102V11.8926H14.1542L13.9961 12.2093C13.7216 12.7515 13.2885 13.2285 12.7305 13.6324L12.326 13.9316L12.5724 14.389C12.7063 14.6151 12.6821 14.8941 12.4841 15.0921C12.4307 15.1477 12.3666 15.192 12.2956 15.2223C12.2247 15.2526 12.1484 15.2682 12.0712 15.2682C11.9941 15.2682 11.9177 15.2526 11.8468 15.2223C11.7758 15.192 11.7117 15.1477 11.6583 15.0921L11.2539 14.6871L11.0255 14.4767L10.7263 14.547C10.2695 14.6522 9.78409 14.7051 9.28516 14.7051C8.80018 14.7068 8.31655 14.6538 7.84347 14.547L7.54534 14.4767L7.31641 14.6876L6.91197 15.0915C6.85857 15.1473 6.79443 15.1916 6.72343 15.222C6.65242 15.2523 6.57602 15.2679 6.49881 15.2679C6.42161 15.2679 6.3452 15.2523 6.2742 15.222C6.20319 15.1916 6.13906 15.1473 6.08566 15.0915C5.99308 15.0019 5.93391 14.8833 5.91795 14.7554C5.90199 14.6275 5.9302 14.498 5.99791 14.3884L6.24428 13.9316L5.83984 13.633C4.82228 12.8938 4.22266 11.8858 4.22266 10.7676C4.22266 8.6627 6.42203 6.83008 9.28516 6.83008C9.97703 6.83008 10.6363 6.93358 11.2365 7.12877L11.5352 7.23452L11.7815 7.02358C12.1832 6.66527 12.6798 6.47233 13.082 6.37333ZM12.6602 9.64258C12.3508 9.64258 12.0977 9.8957 12.0977 10.2051C12.0977 10.5145 12.3508 10.7676 12.6602 10.7676C12.9695 10.7676 13.2227 10.5145 13.2227 10.2051C13.2227 9.8957 12.9695 9.64258 12.6602 9.64258Z"
                                fill="#F15836"
                              />
                            </svg>
                            {`${item.shareValue ? (+item.shareValue).toLocaleString('vi') : 0} VNĐ`}
                          </div>
                          <div className={'flex flex-row items-center space-x-2 text-sm font-normal text-[#818181]'}>
                            <svg
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M3.55859 3.51758H3.56234M3.55859 2.01758H5.43359C5.62559 2.01758 5.81759 2.0907 5.96384 2.23733L8.58884 4.86233C8.72945 5.00297 8.80843 5.1937 8.80843 5.39258C8.80843 5.59145 8.72945 5.78218 8.58884 5.92283L5.96384 8.54783C5.8232 8.68843 5.63247 8.76742 5.43359 8.76742C5.23472 8.76742 5.04399 8.68843 4.90334 8.54783L2.27834 5.92283C2.2086 5.85327 2.15328 5.77063 2.11556 5.67963C2.07785 5.58863 2.05849 5.49108 2.05859 5.39258V3.51758C2.05859 3.11975 2.21663 2.73822 2.49793 2.45692C2.77924 2.17561 3.16077 2.01758 3.55859 2.01758Z"
                                stroke="#818181"
                                strokeWidth="0.75"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                            {`${item.roamingFee ? item.roamingFee.toLocaleString('vi') : 0} VNĐ`}
                          </div>
                        </div>
                      </div>
                      <div className={'grid grid-cols-2 gap-2 border-t border-[#EFEFEF] pt-2'}>
                        <ButtonGradient
                          className={'h-[32px] w-full !rounded-t-[8px] !rounded-bl-[8px]'}
                          background={'bg-white !rounded-t-[6px] !rounded-bl-[6px]'}
                          onClick={() => {
                            if (userLogin?.statusVerify === 1) {
                              navigator?.clipboard?.writeText(item.link);
                              toast.success('Sao chép link thành công!');
                              return;
                            }
                            setIsShowNotification(true);
                          }}
                          // onClick={() => setShowDialog(true)}
                        >
                          <span className={'text-xs font-bold leading-[18px] text-[#F15836]'}>Lấy link</span>
                        </ButtonGradient>
                        <button
                          className={
                            'h-[32px] w-full rounded-t-[8px] rounded-bl-[8px] bg-[#F15836] text-[12px] font-bold text-white' +
                            ' md:hidden'
                          }
                          // onClick={() => {
                          //   if (userLogin?.statusVerify === 1) {
                          //     onHoldSim(item);
                          //     return;
                          //   }
                          //   setIsShowNotification(true);
                          // }}
                          onClick={() => setShowDialog(true)}
                        >
                          Giữ số
                        </button>
                      </div>
                    </div>
                  ))}
                </InfiniteScroll>
              </div>
            )}
          </>
          <>
            {(dataTable.items.length > 0 || currentPage !== 1) && (
              <div className={'mt-6 hidden md:contents'}>
                <div className="pt-4">
                  <PaginationAuto
                    currentPage={currentPage || 1}
                    setCurrentPage={(_page: number) => {
                      setCurrentPage(_page);
                      onSearchSim({ currentPage: _page });
                    }}
                    totalPage={totalPage}
                    perPage={perPage}
                    setPerPage={(_perPage: number) => {
                      setPerPage(_perPage);
                      setCurrentPage(1);
                      onSearchSim({ perPage: _perPage });
                    }}
                    showPages={false}
                  />
                </div>
              </div>
            )}
          </>
          <>{isShowNotification && <AccountAuthen setIsShowNotification={setIsShowNotification} />}</>
          <>
            {isOpenFilter && (
              <PopupFilterSim
                isOpen={isOpenFilter}
                setIsOpen={setIsOpenFilter}
                onSearch={(keySearch: any) => {
                  setIsOpenFilter(false);
                  setCurrentPage(1);
                  setSearchParams({
                    ...keySearch,
                    srcStrs: searchString ? [searchString] : [],
                    page: 1,
                    sizeOfPage: perPage,
                  });
                }}
                listGroupMsisdnOptions={listGroupMsisdnOptions}
              />
            )}
          </>
        </Products>
      </SimContext.Provider>

      <Transition show={showDialog} as={Fragment}>
        <Dialog
          open={showDialog}
          onClose={() => {}}
          className="fixed inset-0 z-50 flex h-full min-h-screen w-screen flex-row items-center justify-center overflow-y-auto bg-[#000000]/60"
        >
          <Dialog.Panel
            className={
              'h-[400px] min-h-[400px] w-[400px] rounded-t-[16px] rounded-bl-[16px] border border-gray-200' +
              ' bg-[#F8F8F8] shadow-base'
            }
          >
            <Dialog.Title className={'mb-2 flex h-fit flex-col items-start px-6 pt-6'}>
              <div className={'flex h-fit w-full flex-row justify-end'}>
                <button type={'button'} onClick={() => setShowDialog(false)}>
                  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_573_26413)">
                      <path
                        d="M0.314708 0.701427C0.414214 0.601669 0.532424 0.522521 0.662566 0.468518C0.792707 0.414515 0.932225 0.386719 1.07313 0.386719C1.21403 0.386719 1.35354 0.414515 1.48369 0.468518C1.61383 0.522521 1.73204 0.601669 1.83154 0.701427L7.5004 6.37242L13.1692 0.701427C13.2688 0.60183 13.3871 0.522825 13.5172 0.468924C13.6473 0.415022 13.7868 0.38728 13.9277 0.38728C14.0685 0.38728 14.208 0.415022 14.3381 0.468924C14.4682 0.522825 14.5865 0.60183 14.6861 0.701427C14.7857 0.801024 14.8647 0.919262 14.9186 1.04939C14.9725 1.17952 15.0002 1.31899 15.0002 1.45984C15.0002 1.6007 14.9725 1.74017 14.9186 1.8703C14.8647 2.00043 14.7857 2.11867 14.6861 2.21826L9.01509 7.88711L14.6861 13.556C14.7857 13.6556 14.8647 13.7738 14.9186 13.9039C14.9725 14.0341 15.0002 14.1735 15.0002 14.3144C15.0002 14.4552 14.9725 14.5947 14.9186 14.7248C14.8647 14.855 14.7857 14.9732 14.6861 15.0728C14.5865 15.1724 14.4682 15.2514 14.3381 15.3053C14.208 15.3592 14.0685 15.3869 13.9277 15.3869C13.7868 15.3869 13.6473 15.3592 13.5172 15.3053C13.3871 15.2514 13.2688 15.1724 13.1692 15.0728L7.5004 9.40181L1.83154 15.0728C1.73195 15.1724 1.61371 15.2514 1.48358 15.3053C1.35345 15.3592 1.21398 15.3869 1.07313 15.3869C0.932275 15.3869 0.792802 15.3592 0.662673 15.3053C0.532543 15.2514 0.414305 15.1724 0.314708 15.0728C0.215111 14.9732 0.136106 14.855 0.0822051 14.7248C0.0283036 14.5947 0.000560851 14.4552 0.000560851 14.3144C0.000560851 14.1735 0.0283036 14.0341 0.0822051 13.9039C0.136106 13.7738 0.215111 13.6556 0.314708 13.556L5.9857 7.88711L0.314708 2.21826C0.21495 2.11876 0.135802 2.00055 0.0817995 1.87041C0.0277966 1.74026 0 1.60075 0 1.45984C0 1.31894 0.0277966 1.17943 0.0817995 1.04928C0.135802 0.919142 0.21495 0.800933 0.314708 0.701427Z"
                        fill="#A9A9A9"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_573_26413">
                        <rect width="15" height="15" fill="white" transform="translate(0 0.386719)" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>
              <div className={'m-4 flex h-fit w-full flex-1 items-center justify-center'}>
                <img src={ComingSoonIcon} alt="image1" className="text-center" />
              </div>
            </Dialog.Title>
            <Dialog.Description className={'flex h-full w-full flex-col items-center px-6 pb-6'}>
              <h2 className={'mb-4 text-[22px] font-extrabold leading-[26px] text-baseColor'}>Thông báo</h2>
              <p className={'text-center text-sm font-medium text-[#818181]'}>
                Vui lòng tải ứng dụng Shop360 để có thể kinh doanh sản phẩm dễ dàng hơn!
              </p>
              <div
                className={
                  'h-[40px] w-full rounded-t-[8px] rounded-bl-[8px] bg-gradient-to-r from-[#F15836]' +
                  ' mt-6 to-[#FF924F] p-[2px]'
                }
              >
                <button className={'h-full w-full rounded-t-[6px] rounded-bl-[6px]'} onClick={redirectDownload}>
                  <span className={'text-sm font-extrabold text-white'}>Tải ứng dụng</span>
                </button>
              </div>
            </Dialog.Description>
          </Dialog.Panel>
        </Dialog>
      </Transition>
    </>
  );
};

const labelHeader = [
  {
    label: 'STT',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase w-[65px]',
  },
  {
    label: 'Nhà mạng',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Số thuê bao',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Loại thuê bao',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Loại số',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Hoa hồng phát triển thuê bao (VNĐ)',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase',
  },
  {
    label: 'Thao tác',
    className: 'text-[#818181] font-semibold text-[10px] leading-[12px] uppercase w-[272px]',
  },
];
